import { makeSchedulable, SchedulablesController } from "./schedulable_helpers"

export default makeSchedulable(class extends SchedulablesController {
  executeConnectLogic() {
    this.removeCardMaybe = this.removeCardMaybe.bind(this)
    App.Helpers.listenToCustomEvent(document, "schedulables:delete-success", this.removeCardMaybe)
  }

  removeCardMaybe(event) {
    const { schedulableID, schedulableType, date, all } = event.detail
    if (schedulableID == this.schedulableID && schedulableType == this.schedulableType && (all || date == this.schedulableDateString)) {
      this.element.remove();
    }
  }
})



// WEBPACK FOOTER //
// ./app/components/schedulables/assets/javascript/schedulables-card-controller.js